module.exports = __webpack_public_path__ + "static/img/start.f6aa4f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Sweeping/start.jpg
// module id = /fsB
// module chunks = 1